import { render, staticRenderFns } from "./video-element.vue?vue&type=template&id=50cd905b&scoped=true&"
import script from "./video-element.vue?vue&type=script&lang=js&"
export * from "./video-element.vue?vue&type=script&lang=js&"
import style0 from "./video-element.vue?vue&type=style&index=0&id=50cd905b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50cd905b",
  null
  
)

export default component.exports